import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const getClubPackageByClubId = (clubId) =>
  axios.get(
    `${getV1RootUrl()}/club-package/next/for-web?clubId=${clubId}`,
    publicAxiosHeader()
  );
